import { createContext } from 'preact-compat'
import { TranslationCategory } from '../libs/translationsUtils/translations'

import communityOverview from '../pages/community-overview'
import groupOverview from '../pages/group-overview'
import { WidgetElement } from '../server-middleware/widgetRepository'

export interface PageContext {
  widgets?: WidgetElement[]
  name: string
  url: string
  breadcrumbs: Array<{phrase: [TranslationCategory, string], url: string}>
}

export interface PageContextWithURL extends PageContext {
  fullUrl: URL
}

const pages: PageContext[] = [
  communityOverview,
  groupOverview
]

export const getPageContext = (currentUrl: URL): PageContextWithURL => {
  for (const page of pages) {
    if (page.url === currentUrl.pathname) {
      return { ...page, fullUrl: currentUrl }
    }
  }

  return { ...page404, fullUrl: currentUrl }
}

export const page404: PageContext = {
  widgets: [],
  name: '404',
  url: '/404',
  breadcrumbs: [
    {
      phrase: ['Common', 'breadcrumb.homepage.text'],
      url: '/'
    }
  ]
}

export const CurrentPageContext = createContext<PageContextWithURL>({
  ...page404,
  fullUrl: new URL('http://127.0.0.1/404')
})
